import {GET_EMPLOYEE} from './constants'

function reject (error) {
  let eobj
  if (error.response) {
    let data = error.response.data
    if (data.errors) {
      eobj = new Error(data.errors)
    } else if (data.message) {
      eobj = new Error(data.message)
    } else {
      eobj = new Error(error.message)
    }
  } else {
    eobj = new Error(error.message)
  }
  return Promise.reject(eobj)
}

export function getEmployee (params) {
  return axios
    .get(GET_EMPLOYEE, {params, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(reject)
}



// WEBPACK FOOTER //
// ./app/api/get-employee/get-employee.js